var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.501 2.01302C12.5383 1.62326 11.4617 1.62326 10.499 2.01302L5.49897 4.03723C3.98852 4.64873 3 6.11537 3 7.74491V13.2645C3.05882 14.7702 3.3 17.8165 6.3 19.6232L10.1194 21.6578C11.295 22.284 12.7051 22.284 13.8806 21.6578L17.7 19.6232C20.7 17.8165 20.9412 14.7702 21 13.2645V7.74491C21 6.11537 20.0115 4.64873 18.501 4.03723L13.501 2.01302Z",
    fill: "#27BF80"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0008,
    cy: 12,
    r: 5.7,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3712 9.81977C15.6768 10.1127 15.6768 10.5875 15.3712 10.8804L11.6146 14.4804C11.309 14.7733 10.8135 14.7733 10.5079 14.4804L8.62961 12.6804C8.32398 12.3875 8.32398 11.9127 8.62961 11.6198C8.93524 11.3269 9.43076 11.3269 9.73639 11.6198L11.0613 12.8894L14.2644 9.81977C14.57 9.52687 15.0655 9.52687 15.3712 9.81977Z",
    fill: "#27BF80"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurity);
export default __webpack_public_path__ + "static/media/icon-security.052bf12f1ccfb98bc0802b7e52e8e5f8.svg";
export { ForwardRef as ReactComponent };